import { AGREGAR_PEDIDO, BORRAR_PEDIDO, VALIDATE_FOR_SALE, VENTAS_PARA_PEDIDO, VENTAS_POR_ID } from '../constants';
import Axios from '../extras/Axios';

export async function obtenerVentasSinEntregar() {
    const resultado = await Axios.get(VENTAS_PARA_PEDIDO)
    if (resultado.status !== 200) return [];
    return await resultado.data;

}

export async function borrarVenta(_id) {
    const resultado = await (await Axios.delete(BORRAR_PEDIDO, { data: { _id } }));
    if (resultado.status !== 200) return false;
    return true;
}

export async function validateProductsAvailability(productIds) {
    return (await Axios.post(VALIDATE_FOR_SALE, productIds)).data;
}

export async function terminarVenta(venta) {
    try {
        const resultado = await Axios.post(AGREGAR_PEDIDO, { venta });

        if (resultado.status === 200) {
            const { message, reservados, notaCredito, saldoInsuficiente } = resultado.data;

            return { message, reservados, notaCredito,saldoInsuficiente };
        }

    } catch (error) {
        console.log('Error al finalizar venta', error);
        return { message: 'Error al finalizar la venta', reservados: [], notaCredito: null };
    }
}

export async function buscarVentaPorId(_id) {
    const resultado = await Axios.get(VENTAS_POR_ID, { params: { _id } });
    if (resultado.status !== 200) return null;
    return await resultado.data;
}